export default {
  nav: {
    home: 'Home',
    shoppingGuide: 'Shopping Guide',
    guide: 'Spreadsheet Guide',
    categories: 'Categories',
    buyNow: 'Buy It Now',
    language: 'Language',
  },
  hero: {
    badge: 'Independent Resource · Updated Regularly · Safety-Focused',
    title: 'USFans Spreadsheet — Find Sellers, Products & Buying Resources',
    subtitle:
      'Explore the latest USFans spreadsheet resources, seller lists, product guides, QC information, shipping tips, reviews and safety resources — all organized in one place.',
    cta1: 'USFans Spreadsheet',
    cta2: 'Buy It Now',
    trust: 'Independent Resource · Updated Regularly · Safety-Focused',
    disclaimer:
      'USFansSheet.link is an independent informational resource and is not necessarily affiliated with USFans. Always verify important information before making a purchase.',
    cardTitle: 'Live Spreadsheet Preview',
    cardSeller: 'Seller',
    cardProduct: 'Product',
    cardCategory: 'Category',
    cardQc: 'QC',
    cardShipping: 'Shipping',
    cardStatus: 'Status',
    cardUpdated: 'Updated',
  },
  categorySection: {
    title: 'Browse Product Categories',
    subtitle:
      'Jump straight to the category you are looking for. Every link opens the matching section on the main website.',
    dropdownLabel: 'Choose a category',
    allCategories: 'All categories',
    goTo: 'Open category',
  },
  about: {
    title: 'What Is a USFans Spreadsheet?',
    subtitle:
      'An organized way to discover products, sellers and buying resources without searching through scattered information.',
    p1: 'A USFans spreadsheet is a structured way to discover products, sellers and useful buying resources without searching through scattered information. Our USFans Spreadsheet hub organizes seller information, product categories, QC resources, shipping guides and related buying information into an easier-to-use format.',
    p2: 'Whether you are looking for shoes, hoodies, t-shirts, bags or accessories, you can start here and continue to the main website to browse the full catalog.',
    cta: 'Explore the USFans Spreadsheet',
  },
  features: {
    title: 'Everything You Need to Explore USFans in One Place',
    subtitle: 'A clear starting point for sellers, products, QC, shipping and safety.',
    seller: {
      title: 'Seller Discovery',
      desc: 'Find organized seller resources and compare relevant information.',
    },
    product: {
      title: 'Product Discovery',
      desc: 'Explore popular product categories and related spreadsheet resources.',
    },
    qc: {
      title: 'QC Resources',
      desc: 'Learn how QC information and photos can help evaluate products.',
    },
    shipping: {
      title: 'Shipping Guides',
      desc: 'Understand shipping methods, costs and important considerations.',
    },
    safety: {
      title: 'Safety Resources',
      desc: 'Learn how to evaluate links, sellers, payments and buying risks.',
    },
    updated: {
      title: 'Updated Resources',
      desc: 'Keep important information organized and easier to revisit.',
    },
  },
  article: {
    title: 'USFans Spreadsheet Guide',
    subtitle:
      'Read our in-depth guide to understand sellers, products, QC, shipping and safety before you buy.',
    cardTitle: 'USFans Spreadsheet: The Complete Guide',
    cardDesc:
      'Learn what a USFans spreadsheet is, how to find sellers and products, and how to buy safely.',
    readMore: 'Read the full guide',
    readGuide: 'Open the guide',
    minutes: '7 min read',
    related: 'Related Guides',
    tableTitle: 'Quick Reference Table',
    pros: 'Pros',
    cons: 'Cons',
    notFound: 'Guide not found',
  },
  articleSection: {
    title: 'USFans Guides & Resources',
    subtitle:
      'Explore our library of independent guides covering sellers, products, QC, shipping, coupons, safety and more.',
  },
  faq: {
    title: 'Frequently Asked Questions',
    subtitle: 'Quick answers to the most common questions about the USFans spreadsheet.',
    q1: {
      q: 'What is a USFans spreadsheet?',
      a: 'A USFans spreadsheet is an organized table that gathers sellers, products, categories, QC information and shipping notes in one place.',
    },
    q2: {
      q: 'Is USFansSheet.link affiliated with USFans?',
      a: 'No. USFansSheet.link is an independent informational resource and is not necessarily affiliated with USFans.',
    },
    q3: {
      q: 'How do I find products?',
      a: 'Use the category directory on this page to jump to shoes, hoodies, t-shirts and other categories on the main website.',
    },
    q4: {
      q: 'Should I check QC before buying?',
      a: 'Yes. Reviewing QC photos and notes can help you confirm an item matches its description before it ships.',
    },
  },
  cta: {
    title: 'Ready to Explore the USFans Spreadsheet?',
    subtitle:
      'Start with the spreadsheet hub, compare available resources and find the information you need before continuing to the main website.',
    button1: 'Open USFans Spreadsheet',
    button2: 'Buy It Now',
  },
  footer: {
    tagline:
      'An independent resource hub for discovering USFans sellers, products, QC and buying information.',
    disclaimer:
      'USFansSheet.link is an independent informational resource and is not necessarily affiliated with or endorsed by USFans. Information may change — verify details through official sources.',
    categories: 'Categories',
    resources: 'Resources',
    guide: 'Spreadsheet Guide',
    home: 'Home',
    backToTop: 'Back to top',
    rights: 'All rights reserved.',
  },
  categoryNames: {
    shoes: 'Shoes',
    hoodies: 'Hoodies / Sweaters',
    tshirts: 'T-Shirts',
    jackets: 'Jackets',
    pants: 'Pants / Shorts',
    headwear: 'Headwear',
    sets: 'Sets',
    underwear: 'Underwear / Underpants',
    jersey: 'Jersey',
    accessories: 'Accessories',
    bags: 'Bags',
    belts: 'Belts',
    perfumes: 'Perfumes',
    other: 'Other Stuff',
  },
};